import { render, staticRenderFns } from "./DepartWindow.vue?vue&type=template&id=228f7c62&scoped=true&"
import script from "./DepartWindow.vue?vue&type=script&lang=js&"
export * from "./DepartWindow.vue?vue&type=script&lang=js&"
import style0 from "./DepartWindow.vue?vue&type=style&index=0&id=228f7c62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f7c62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228f7c62')) {
      api.createRecord('228f7c62', component.options)
    } else {
      api.reload('228f7c62', component.options)
    }
    module.hot.accept("./DepartWindow.vue?vue&type=template&id=228f7c62&scoped=true&", function () {
      api.rerender('228f7c62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DepartWindow.vue"
export default component.exports